import * as http from 'axios'

export const login = (credentials) => {
  return http.post('/auth', credentials)
}
export const loginCliente = (credentials) => {
  return http.post('/auth/cliente', credentials)
}



// WEBPACK FOOTER //
// ./src/store/auth/services.js